import TemplateAvatar from "../components/TemplateAvatar";
import { Crown, Import } from 'lucide-react';
import { GridListDataSource } from "../components/GridList";
import { Avatar } from "antd";

export const AWS_REGIONS = [
    {
        "id": "UsEast2",
        "value": "us-east-2",
        "name": "US East (Ohio)",
    },
    {
        "id": 'UsEast1',
        "value": "us-east-1",
        "name": "US East (N. Virginia)"
    },
    {
        "id": "UsWest1",
        "value": "us-west-1",
        "name": "US West (N. California)"
    },
    {
        "id": "UsWest2",
        "value": "us-west-2",
        "name": "US West (Oregon)"
    },
    {
        "id": "ApEast1",
        "value": "ap-east-1",
        "name": "Asia Pacific (Hong Kong)"
    },
    {
        "id": "ApSouth1",
        "value": "ap-south-1",
        "name": "Asia Pacific (Mumbai)"
    },
    {
        "id": "ApNortheast3",
        "value": "ap-northeast-3",
        "name": "Asia Pacific (Osaka-Local)"
    },
    {
        "id": "ApNortheast2",
        "value": "ap-northeast-2",
        "name": "Asia Pacific (Seoul)"
    },
    {
        "id": "ApSoutheast1",
        "value": "ap-southeast-1",
        "name": "Asia Pacific (Singapore)"
    },
    {
        "id": "ApSoutheast2",
        "value": "ap-southeast-2",
        "name": "Asia Pacific (Sydney)"
    },
    {
        "id": "ApNortheast1",
        "value": "ap-northeast-1",
        "name": "Asia Pacific (Tokyo)"
    },
    {
        "id": "CaCentral1",
        "value": "ca-central-1",
        "name": "Canada (Central)"
    },
    {
        "id": "CnNorth1",
        "value": "cn-north-1",
        "name": "China (Beijing)"
    },
    {
        "id": "CnNorthwest1",
        "value": "cn-northwest-1",
        "name": "China (Ningxia)"
    },
    {
        "id": "EuCentral1",
        "value": "eu-central-1",
        "name": "EU (Frankfurt)"
    },
    {
        "id": "EuWest1",
        "value": "eu-west-1",
        "name": "EU (Ireland)"
    },
    {
        "id": "EuWest2",
        "value": "eu-west-2",
        "name": "EU (London)"
    },
    {
        "id": "EuWest3",
        "value": "eu-west-3",
        "name": "EU (Paris)"
    },
    {
        "id": "EuNorth1",
        "value": "eu-north-1",
        "name": "EU (Stockholm)"
    },
    {
        "id": "MeSouth1",
        "value": "me-south-1",
        "name": "Middle East (Bahrain)"
    },
    {
        "id": "SaEast1",
        "value": "sa-east-1",
        "name": "South America (São Paulo)"
    }
];

export const GCP_REGIONS = [
    {
        "id": "AfricaSouth1",
        "name": "South Africa (Johannesburg)",
        "value": "africa-south1"
    },
    {
        "id": "AsiaEast1",
        "name": "APAC (Changhua County, Taiwan)",
        "value": "asia-east1"
    },
    {
        "id": "AsiaEast2",
        "name": "APAC (Hong Kong)",
        "value": "asia-east2"
    },
    {
        "id": "AsiaNortheast1",
        "name": "APAC (Tokyo, Japan)",
        "value": "asia-northeast1"
    },
    {
        "id": "AsiaNortheast2",
        "name": "APAC (Osaka, Japan)",
        "value": "asia-northeast2"
    },
    {
        "id": "AsiaNortheast3",
        "name": "APAC (Seoul, South Korea)",
        "value": "asia-northeast3"
    },
    {
        "id": "AsiaSouth1",
        "name": "APAC (Mumbai, India)",
        "value": "asia-south1"
    },
    {
        "id": "AsiaSouth2",
        "name": "APAC (Delhi, India)",
        "value": "asia-south2"
    },
    {
        "id": "AsiaSoutheast1",
        "name": "APAC (Jurong West, Singapore)",
        "value": "asia-southeast1"
    },
    {
        "id": "AsiaSoutheast2",
        "name": "APAC (Jakarta, Indonesia)",
        "value": "asia-southeast2"
    },
    {
        "id": "AustraliaSoutheast1",
        "name": "APAC (Sydney, Australia)",
        "value": "australia-southeast1"
    },
    {
        "id": "AustraliaSoutheast2",
        "name": "APAC (Melbourne, Australia)",
        "value": "australia-southeast2"
    },
    {
        "id": "EuropeCentral2",
        "name": "Europe (Warsaw, Poland)",
        "value": "europe-central2"
    },
    {
        "id": "EuropeNorth1",
        "name": "Europe (Hamina, Finland)",
        "value": "europe-north1"
    },
    {
        "id": "EuropeSouthwest1",
        "name": "Europe (Madrid, Spain)",
        "value": "europe-southwest1"
    },
    {
        "id": "EuropeWest10",
        "name": "Europe (Berlin, Germany)",
        "value": "europe-west10"
    },
    {
        "id": "EuropeWest12",
        "name": "Europe (Turin, Italy)",
        "value": "europe-west12"
    },
    {
        "id": "EuropeWest1",
        "name": "Europe (St. Ghislain, Belgium)",
        "value": "europe-west1"
    },
    {
        "id": "EuropeWest2",
        "name": "Europe (London, England)",
        "value": "europe-west2"
    },
    {
        "id": "EuropeWest3",
        "name": "Europe (Frankfurt, Germany)",
        "value": "europe-west3"
    },
    {
        "id": "EuropeWest4",
        "name": "Europe (Eemshaven, Netherlands)",
        "value": "europe-west4"
    },
    {
        "id": "EuropeWest6",
        "name": "Europe (Zurich, Switzerland)",
        "value": "europe-west6"
    },
    {
        "id": "EuropeWest8",
        "name": "Europe (Milan, Italy)",
        "value": "europe-west8"
    },
    {
        "id": "EuropeWest9",
        "name": "Europe (Paris, France)",
        "value": "europe-west9"
    },
    {
        "id": "MeCentral1",
        "name": "Middle East (Doha, Qatar)",
        "value": "me-central1",
    },
    {
        "id": "MeCentral2",
        "name": "Middle East (Dammam, Saudi Arabia)",
        "value": "me-central2",
    },
    {
        "id": "MeWest1",
        "name": "Middle East (Tel Aviv, Israel)",
        "value": "me-west1",
    },
    {
        "id": "NorthamericaNortheast1",
        "name": "North America (Montréal, Québec)",
        "value": "northamerica-northeast1"
    },
    {
        "id": "NorthamericaNortheast2",
        "name": "North America (Toronto, Ontario)",
        "value": "northamerica-northeast2"
    },
    {
        "id": "UsCentral1",
        "name": "North America (Council Bluffs, Iowa)",
        "value": "us-central1"
    },
    {
        "id": "UsEast1",
        "name": "North America (Moncks Corner, South Carolina)",
        "value": "us-east1"
    },
    {
        "id": "UsEast4",
        "name": "North America (Ashburn,  Virginia)",
        "value": "us-east4"
    },
    {
        "id": "UsEast5",
        "name": "North America (Columbus, Ohio)",
        "value": "us-east5"
    },
    {
        "id": "UsSouth1",
        "name": "North America (Dallas, Texas)",
        "value": "us-south1"
    },
    {
        "id": "UsWest1",
        "name": "North America (The Dalles, Oregon)",
        "value": "us-west1"
    },
    {
        "id": "UsWest2",
        "name": "North America (Los Angeles, California)",
        "value": "us-west2"
    },
    {
        "id": "UsWest3",
        "name": "North America (Salt Lake City, Utah)",
        "value": "us-west3"
    },
    {
        "id": "UsWest4",
        "name": "North America (Las Vegas, Nevada)",
        "value": "us-west4"
    },
    {
        "id": "SouthamericaEast1",
        "name": "South America (São Paulo, Brazil)",
        "value": "southamerica-east1"
    },
    {
        "id": "SouthamericaWest1",
        "name": "South America (Santiago, Chile)",
        "value": "southamerica-west1"
    }
];

export const GCP_ZONES = [
    {
        "id": "AfricaSouth1A",
        "name":"africa-south1-a"
    },
    {
        "id": "AfricaSouth1B",
        "name":"africa-south1-b"
    },
    {
        "id": "AfricaSouth1C",
        "name":"africa-south1-c"
    },
    {
        "id": "AsiaEast1A",
        "name": "asia-east1-a"
    },
    {
        "id": "AsiaEast1B",
        "name": "asia-east1-b"
    },
    {
        "id": "AsiaEast1C",
        "name": "asia-east1-c"
    },
    {
        "id": "AsiaEast2A",
        "name": "asia-east2-a"
    },
    {
        "id": "AsiaEast2B",
        "name": "asia-east2-b"
    },
    {
        "id": "AsiaEast2C",
        "name": "asia-east2-c"
    },
    {
        "id": "AsiaNortheast1A",
        "name": "asia-northeast1-a"
    },
    {
        "id": "AsiaNortheast1B",
        "name": "asia-northeast1-b"
    },
    {
        "id": "AsiaNortheast1C",
        "name": "asia-northeast1-c"
    },
    {
        "id": "AsiaNortheast2A",
        "name": "asia-northeast2-a"
    },
    {
        "id": "AsiaNortheast2B",
        "name": "asia-northeast2-b"
    },
    {
        "id": "AsiaNortheast2C",
        "name": "asia-northeast2-c"
    },
    {
        "id": "AsiaNortheast3A",
        "name": "asia-northeast3-a"
    },
    {
        "id": "AsiaNortheast3B",
        "name": "asia-northeast3-b"
    },
    {
        "id": "AsiaNortheast3C",
        "name": "asia-northeast3-c"
    },
    {
        "id": "AsiaSouth1A",
        "name": "asia-south1-a"
    },
    {
        "id": "AsiaSouth1B",
        "name": "asia-south1-b"
    },
    {
        "id": "AsiaSouth1C",
        "name": "asia-south1-c"
    },
    {
        "id": "AsiaSouth2A",
        "name": "asia-south2-a"
    },
    {
        "id": "AsiaSouth2B",
        "name": "asia-south2-b"
    },
    {
        "id": "AsiaSouth2C",
        "name": "asia-south2-c"
    },
    {
        "id": "AsiaSoutheast1A",
        "name": "asia-southeast1-a"
    },
    {
        "id": "AsiaSoutheast1B",
        "name": "asia-southeast1-b"
    },
    {
        "id": "AsiaSoutheast1C",
        "name": "asia-southeast1-c"
    },
    {
        "id": "AsiaSoutheast2A",
        "name": "asia-southeast2-a"
    },
    {
        "id": "AsiaSoutheast2B",
        "name": "asia-southeast2-b"
    },
    {
        "id": "AsiaSoutheast2C",
        "name": "asia-southeast2-c"
    },
    {
        "id": "AustraliaSoutheast1A",
        "name": "australia-southeast1-a"
    },
    {
        "id": "AustraliaSoutheast1B",
        "name": "australia-southeast1-b"
    },
    {
        "id": "AustraliaSoutheast1C",
        "name": "australia-southeast1-c"
    },
    {
        "id": "AustraliaSoutheast2A",
        "name": "australia-southeast2-a"
    },
    {
        "id": "AustraliaSoutheast2B",
        "name": "australia-southeast2-b"
    },
    {
        "id": "AustraliaSoutheast2C",
        "name": "australia-southeast2-c"
    },
    {
        "id": "EuropeCentral2A",
        "name": "europe-central2-a"
    },
    {
        "id": "EuropeCentral2B",
        "name": "europe-central2-b"
    },
    {
        "id": "EuropeCentral2C",
        "name": "europe-central2-c"
    },
    {
        "id": "EuropeNorth1A",
        "name": "europe-north1-a"
    },
    {
        "id": "EuropeNorth1B",
        "name": "europe-north1-b"
    },
    {
        "id": "EuropeNorth1C",
        "name": "europe-north1-c"
    },
    {
        "id": "EuropeSouthwest1A",
        "name": "europe-southwest1-a"
    },
    {
        "id": "EuropeSouthwest1B",
        "name": "europe-southwest1-b"
    },
    {
        "id": "EuropeSouthwest1C",
        "name": "europe-southwest1-c"
    },
    {
        "id": "EuropeWest10A",
        "name": "europe-west10-a"
    },
    {
        "id": "EuropeWest10B",
        "name": "europe-west10-b"
    },
    {
        "id": "EuropeWest10C",
        "name": "europe-west10-c"
    },
    {
        "id": "EuropeWest12A",
        "name": "europe-west12-a"
    },
    {
        "id": "EuropeWest12B",
        "name": "europe-west12-b"
    },
    {
        "id": "EuropeWest12C",
        "name": "europe-west12-c"
    },
    {
        "id": "EuropeWest1B",
        "name": "europe-west1-b"
    },
    {
        "id": "EuropeWest1C",
        "name": "europe-west1-c"
    },
    {
        "id": "EuropeWest1D",
        "name": "europe-west1-d"
    },
    {
        "id": "EuropeWest2A",
        "name": "europe-west2-a"
    },
    {
        "id": "EuropeWest2B",
        "name": "europe-west2-b"
    },
    {
        "id": "EuropeWest2C",
        "name": "europe-west2-c"
    },
    {
        "id": "EuropeWest3A",
        "name": "europe-west3-a"
    },
    {
        "id": "EuropeWest3B",
        "name": "europe-west3-b"
    },
    {
        "id": "EuropeWest3C",
        "name": "europe-west3-c"
    },
    {
        "id": "EuropeWest4A",
        "name": "europe-west4-a"
    },
    {
        "id": "EuropeWest4B",
        "name": "europe-west4-b"
    },
    {
        "id": "EuropeWest4C",
        "name": "europe-west4-c"
    },
    {
        "id": "EuropeWest6A",
        "name": "europe-west6-a"
    },
    {
        "id": "EuropeWest6B",
        "name": "europe-west6-b"
    },
    {
        "id": "EuropeWest6C",
        "name": "europe-west6-c"
    },
    {
        "id": "EuropeWest8A",
        "name": "europe-west8-a"
    },
    {
        "id": "EuropeWest8B",
        "name": "europe-west8-b"
    },
    {
        "id": "EuropeWest8C",
        "name": "europe-west8-c"
    },
    {
        "id": "EuropeWest9A",
        "name": "europe-west9-a"
    },
    {
        "id": "EuropeWest9B",
        "name": "europe-west9-b"
    },
    {
        "id": "EuropeWest9C",
        "name": "europe-west9-c"
    },
    {
        "id": "MeCentral1A",
        "name": "me-central1-a"
    },
    {
        "id": "MeCentral1B",
        "name": "me-central1-b"
    },
    {
        "id": "MeCentral1C",
        "name": "me-central1-c"
    },
    {
        "id": "MeCentral2A",
        "name": "me-central2-a"
    },
    {
        "id": "MeCentral2B",
        "name": "me-central2-b"
    },
    {
        "id": "MeCentral2C",
        "name": "me-central2-c"
    },
    {
        "id": "MeWest1A",
        "name": "me-west1-a"
    },
    {
        "id": "MeWest1B",
        "name": "me-west1-b"
    },
    {
        "id": "MeWest1C",
        "name": "me-west1-c"
    },
    {
        "id": "NorthamericaNortheast1A",
        "name": "northamerica-northeast1-a"
    },
    {
        "id": "NorthamericaNortheast1B",
        "name": "northamerica-northeast1-b"
    },
    {
        "id": "NorthamericaNortheast1C",
        "name": "northamerica-northeast1-c"
    },
    {
        "id": "NorthamericaNortheast2A",
        "name": "northamerica-northeast2-a"
    },
    {
        "id": "NorthamericaNortheast2B",
        "name": "northamerica-northeast2-b"
    },
    {
        "id": "NorthamericaNortheast2C",
        "name": "northamerica-northeast2-c"
    },
    {
        "id": "SouthamericaEast1A",
        "name": "southamerica-east1-a"
    },
    {
        "id": "SouthamericaEast1B",
        "name": "southamerica-east1-b"
    },
    {
        "id": "SouthamericaEast1C",
        "name": "southamerica-east1-c"
    },
    {
        "id": "SouthamericaWest1A",
        "name": "southamerica-west1-a",
    },
    {
        "id": "SouthamericaWest1B",
        "name": "southamerica-west1-b",
    },
    {
        "id": "SouthamericaWest1C",
        "name": "southamerica-west1-c",
    },
    {
        "id": "UsCentral1A",
        "name": "us-central1-a"
    },
    {
        "id": "UsCentral1B",
        "name": "us-central1-b"
    },
    {
        "id": "UsCentral1C",
        "name": "us-central1-c"
    },
    {
        "id": "UsCentral1F",
        "name": "us-central1-f"
    },
    {
        "id": "UsEast1B",
        "name": "us-east1-b"
    },
    {
        "id": "UsEast1C",
        "name": "us-east1-c"
    },
    {
        "id": "UsEast1D",
        "name": "us-east1-d"
    },
    {
        "id": "UsEast4A",
        "name": "us-east4-a"
    },
    {
        "id": "UsEast4B",
        "name": "us-east4-b"
    },
    {
        "id": "UsEast4C",
        "name": "us-east4-c"
    },
    {
        "id": "UsEast5A",
        "name": "us-east5-a"
    },
    {
        "id": "UsEast5B",
        "name": "us-east5-b"
    },
    {
        "id": "UsEast5C",
        "name": "us-east5-c"
    },
    {
        "id": "UsSouth1A",
        "name": "us-south1-a"
    },
    {
        "id": "UsSouth1B",
        "name": "us-south1-b"
    },
    {
        "id": "UsSouth1C",
        "name": "us-south1-c"
    },
    {
        "id": "UsWest1A",
        "name": "us-west1-a"
    },
    {
        "id": "UsWest1B",
        "name": "us-west1-b"
    },
    {
        "id": "UsWest1C",
        "name": "us-west1-c"
    },
    {
        "id": "UsWest2A",
        "name": "us-west2-a"
    },
    {
        "id": "UsWest2B",
        "name": "us-west2-b"
    },
    {
        "id": "UsWest2C",
        "name": "us-west2-c"
    },
    {
        "id": "UsWest3A",
        "name": "us-west3-a"
    },
    {
        "id": "UsWest3B",
        "name": "us-west3-b"
    },
    {
        "id": "UsWest3C",
        "name": "us-west3-c"
    },
    {
        "id": "UsWest4A",
        "name": "us-west4-a"
    },
    {
        "id": "UsWest4B",
        "name": "us-west4-b"
    },
    {
        "id": "UsWest4C",
        "name": "us-west4-c"
    }
];

export const EXOSCALE_ZONES = [
    {
        "id": "AtVie1",
        "name": "Vienna, Austria",
        "value": "at-vie-1"
    },
    {
        "id": "AtVie2",
        "name": "Vienna 2, Austria",
        "value": "at-vie-2"
    },
    {
        "id": "ChDk2",
        "name": "Zurich, Switzerland",
        "value": "ch-dk-2"
    },
    {
        "id": "DeFra1",
        "name": "Frankfurt, Germany",
        "value": "de-fra-1"
    },
    {
        "id": "DeMuc1",
        "name": "Munich, Germany",
        "value": "de-muc-1"
    },
    {
        "id": "BgSof1",
        "name": "Sofia, Bulgaria",
        "value": "bg-sof-1"
    },
    {
        "id": "ChGva2",
        "name": "Geneva, Switzerland",
        "value": "ch-gva-2"
    },
    {
        "id": "HrZag1",
        "name": "Zagreb, Croatia",
        "value": "hr-zag-1"
    }
];

export enum PricingPlanNames {
    FREE = "FREE",
    STARTER = "STARTER",
    ADVANCED = "ADVANCED",
    CUSTOM = "CUSTOM"
}
export const PRICING_PLANS = [{
    id: PricingPlanNames.STARTER,
    displayOrder: 1,
    name: "Starter",
    description: "Launch and manage production-ready apps.",
    price: "$49",
    trial: "7 days free trial",
    features: [
        "2 Environments",
        "2 Applications",
        "30 Deployments",
        "500 Builds minutes",
        "Custom domains",
        "Integrated CI/CD",
        "Slack integration"
    ]
}, {
    id: PricingPlanNames.ADVANCED,
    displayOrder: 2,
    name: "Advanced",
    description: "Optimize resources and manage complex infrastructure.",
    price: "$499",
    trial: "7 days free trial",
    bordered: true,
    features: [
        "10 Environments",
        "Unlimited Applications",
        "Unlimited Deployments",
        "3000 Builds minutes",
        "Custom domains",
        "Automated rollbacks",
        "Deployment Insights"
    ]
}, {
    id: PricingPlanNames.CUSTOM,
    displayOrder: 3,
    name: "Enterprise",
    description: "Custom features, tailored support, and scaled resources.",
    features: [
        "Custom Environments",
        "Custom Applications",
        "Custom Deployments",
        "Custom Infrastructure Components",
        "Custom Infrastructure Templates",
        "Cloud Waste Manager",
        "Shared Infrastructure",
        "Environment Replication",
        "Multi-Cloud support",
        "Chat support (working hours)",
        "24x7x365 support"
    ]
}];

export const PERMISSIONS = {
    "Owner": "User can do EVERYTHING in the system.",
    "Admin": "User can create components, services, environments, saving schedule, trigger builds and deployments and manage users. User cannot update/delete project.",
    "Write": "User can create components, services, environments, saving schedule, trigger builds and deployments. User cannot manage users in the project.",
    "Read": "User can view everything in the system but will not be allowed to modify anything."
}

export const PIPELINE_BUILD_STATUS_CODES: { [key: string]: string } = {
    AUTOMATED_DEPLOY_UNAVAILABLE: "The deployment couldn’t be initiated as automated deployments are not available on your current plan. Upgrade or manually trigger the deployment.",
    DEPLOYMENTS_USED: "The deployment cannot be initiated since the limit for deployments has been exceeded on your current plan. Upgrade for more deployments."
}

export const GIT_TYPES = {
    "github": "GitHub",
    "bitbucket": "Bitbucket",
    "gitlab": "GitLab"
}

export type LOGIN_TYPE = "email" | "github" | "google";

export const EKS_KEY = "eks";

export const TEMPLATES: GridListDataSource[] = [
    {
        key: "import-app",
        title: "Import existing app",
        description: "Import an existing app from your own repository",
        link: "https://raw.githubusercontent.com/microtica/templates/master/import-app/template.yaml&import=true",
        avatar: <Avatar size="large" shape="square" style={{ backgroundColor: "var(--layout-body-background)" }} icon={<Import size={18} color="rgba(0, 0, 0, 0.85)" />} />,
        pack: "free",
        deploymentTarget: "kubernetes",
        iac: "kubernetes",
        className: "import-app-grid-item"
    },
    {
        key: "cloudformation",
        title: "Custom AWS Component",
        description: "Craft your own AWS infrastructure with CloudFormation.",
        link: "https://raw.githubusercontent.com/microtica/templates/master/aws-custom/.microtica/template.yaml",
        avatar: <TemplateAvatar size="large" shape="square" name="cloudformation" />,
        pack: "starter",
        cloudProvider: "aws",
        iac: "cloudformation",
        className: "import-app-grid-item",
        group: "resources",
        type: "component"
    },
    {
        key: "aws-terraform-custom",
        title: "Custom AWS Component",
        description: "Craft your own AWS infrastructure with Terraform.",
        link: "https://raw.githubusercontent.com/microtica/templates/master/aws-tf-custom/.microtica/template.yaml",
        avatar: <TemplateAvatar size="large" shape="square" name="terraform" />,
        pack: "starter",
        cloudProvider: "aws",
        iac: "terraform",
        className: "import-app-grid-item",
        group: "resources",
        type: "component"
    },
    {
        key: "terraform",
        title: "Custom GCP Component",
        description: "Craft your own GCP infrastructure with Terraform.",
        link: "https://raw.githubusercontent.com/microtica/templates/master/gcp-custom/.microtica/template.yaml",
        avatar: <TemplateAvatar size="large" shape="square" name="terraform" />,
        pack: "starter",
        cloudProvider: "google",
        iac: "terraform",
        className: "import-app-grid-item",
        group: "resources",
        type: "component"
    },
    {
        key: "connect-kubernetes",
        title: "Connect Existing Kubernetes Cluster",
        description: "Bring your own existing Kubernetes cluster.",
        // link: "https://raw.githubusercontent.com/microtica/templates/master/aws-custom/.microtica/template.yaml",
        avatar: <TemplateAvatar size="large" shape="square" name="eks" />,
        pack: "free",
        className: "import-app-grid-item",
        group: "resources"
    },
    {
        key: "strapi-serverless",
        title: "Strapi Serverless",
        description: "Strapi is the leading open-source headless CMS.",
        link: "https://raw.githubusercontent.com/microtica/templates/master/strapi-serverless/.microtica/template.yaml",
        avatar: <TemplateAvatar size="large" shape="square" name="strapi-serverless" />,
        pack: "starter",
        deploymentTarget: "fargate",
        cloudProvider: "aws",
        iac: "cloudformation",
        type: "component",
        tags: [
            {
                position: "top",
                value: <>
                    <Crown size={14} color="goldenrod" />&nbsp;
                    <span style={{ color: "GrayText", fontSize: 12 }}>Starter</span>
                </>
            }
        ]
    },
    {
        key: "medusa-server",
        title: "Medusa",
        description: "Elevating online shopping with innovation and personalization.",
        link: "https://raw.githubusercontent.com/microtica/templates/master/medusa-server/.microtica/template.yaml",
        avatar: <TemplateAvatar size="large" shape="square" name="medusa" />,
        pack: "starter",
        deploymentTarget: "fargate",
        cloudProvider: "aws",
        iac: "cloudformation",
        type: "component",
        tags: [
            {
                position: "top",
                value: <>
                    <Crown size={14} color="goldenrod" />&nbsp;
                    <span style={{ color: "GrayText", fontSize: 12 }}>Starter</span>
                </>

            }
        ]
    },
    {
        key: "medusa-b2b-commerce",
        title: "Medusa B2B Commerce",
        description: "Elevating online shopping with innovation and personalization.",
        link: "https://raw.githubusercontent.com/microtica/templates/master/medusa-b2b-commerce/.microtica/template.yaml",
        avatar: <TemplateAvatar size="large" shape="square" name="medusa" />,
        pack: "starter",
        deploymentTarget: "fargate",
        cloudProvider: "aws",
        iac: "cloudformation",
        type: "component",
        tags: [
            {
                position: "top",
                value: <>
                    <Crown size={14} color="goldenrod" />&nbsp;
                    <span style={{ color: "GrayText", fontSize: 12 }}>Starter</span>
                </>

            }
        ]
    },
    {
        key: "n8n",
        title: "n8n.io",
        description: "n8n helps you to interconnect every app with an API.",
        link: "https://raw.githubusercontent.com/microtica/templates/master/n8n/.microtica/template.yaml",
        avatar: <TemplateAvatar size="large" shape="square" name="n8n" />,
        pack: "starter",
        deploymentTarget: "kubernetes",
        iac: "kubernetes",
        cloudProvider: "aws",
        type: "app",
        tags: [
            {
                position: "top",
                value: <>
                    <Crown size={14} color="goldenrod" />&nbsp;
                    <span style={{ color: "GrayText", fontSize: 12 }}>Starter</span>
                </>
            }
        ]
    },
    {
        key: "nodejs",
        title: "Node.js (Express)",
        description: "Node.js is an open-source, cross-platform, back-end JavaScript runtime environment that runs on a JavaScript engine.",
        link: "https://raw.githubusercontent.com/microtica/templates/master/nodejs/.microtica/template.yaml",
        avatar: <TemplateAvatar size="large" shape="square" name="nodejs" />,
        pack: "free",
        deploymentTarget: "kubernetes",
        iac: "kubernetes",
        type: "app",
        tags: [
            {
                position: "top",
                value: <span style={{ color: "GrayText", fontSize: 12 }}>Free</span>
            }
        ]
    },
    {
        key: "nextjs",
        title: "Next.js",
        description: "Next.js gives you the best developer experience with all the features you need for production.",
        link: "https://raw.githubusercontent.com/microtica/templates/master/nextjs/.microtica/template.yaml",
        avatar: <TemplateAvatar size="large" shape="square" name="nextjs" />,
        pack: "free",
        deploymentTarget: "kubernetes",
        iac: "kubernetes",
        type: "app",
        tags: [
            {
                position: "top",
                value: <span style={{ color: "GrayText", fontSize: 12 }}>Free</span>
            }
        ]
    },
    {
        key: "reactjs",
        title: "ReactJS",
        description: "A JavaScript library for building user interfaces.",
        link: "https://raw.githubusercontent.com/microtica/templates/master/reactjs/.microtica/template.yaml",
        avatar: <TemplateAvatar size="large" shape="square" name="reactjs" />,
        pack: "free",
        deploymentTarget: "kubernetes",
        iac: "kubernetes",
        type: "app",
        tags: [
            {
                position: "top",
                value: <span style={{ color: "GrayText", fontSize: 12 }}>Free</span>
            }
        ]
    },
    {
        key: "appwrite",
        title: "Appwrite (beta)",
        description: "Secure Open-Source Backend Server for Web, Mobile & Flutter Developers.",
        avatar: <TemplateAvatar size="large" shape="square" name="appwrite" />,
        link: "https://raw.githubusercontent.com/microtica/templates/master/appwrite/.microtica/template.yaml",
        pack: "free",
        cloudProvider: "aws",
        deploymentTarget: "kubernetes",
        iac: "kubernetes",
        type: "app",
        tags: [
            {
                position: "top",
                value: <span style={{ color: "GrayText", fontSize: 12 }}>Free</span>
            }
        ]
    },
    {
        key: "aws-lambda-golang",
        title: "Lambda (Golang)",
        description: "A Lambda function written in Go language exposed through an API Gateway.",
        link: "https://raw.githubusercontent.com/microtica/templates/master/aws-lambda-golang/.microtica/template.yaml",
        avatar: <TemplateAvatar size="large" shape="square" name="lambda" />,
        pack: "free",
        cloudProvider: "aws",
        iac: "cloudformation",
        type: "component",
        tags: [
            {
                position: "top",
                value: <span style={{ color: "GrayText", fontSize: 12 }}>Free</span>
            }
        ]
    },
    {
        key: "nuxtjs",
        title: "NuxtJS",
        description: "An open source framework for Vue.js making web development simple and powerful.",
        link: "https://raw.githubusercontent.com/microtica/templates/master/nuxtjs/.microtica/template.yaml",
        avatar: <TemplateAvatar size="large" shape="square" name="nuxtjs" />,
        pack: "free",
        deploymentTarget: "kubernetes",
        iac: "kubernetes",
        type: "app",
        tags: [
            {
                position: "top",
                value: <span style={{ color: "GrayText", fontSize: 12 }}>Free</span>
            }
        ]
    },
    {
        key: "angular",
        title: "Angular",
        description: "Angular is a framework for developing single page web applications.",
        link: "https://raw.githubusercontent.com/microtica/templates/master/angularjs/.microtica/template.yaml",
        avatar: <TemplateAvatar size="large" shape="square" name="angular" />,
        pack: "free",
        deploymentTarget: "kubernetes",
        iac: "kubernetes",
        type: "app",
        tags: [
            {
                position: "top",
                value: <span style={{ color: "GrayText", fontSize: 12 }}>Free</span>
            }
        ]
    },
    {
        key: "vuejs",
        title: "Vue.js",
        description: "An approachable, performant and versatile framework for building web user interfaces.",
        link: "https://raw.githubusercontent.com/microtica/templates/master/vuejs/.microtica/template.yaml",
        avatar: <TemplateAvatar size="large" shape="square" name="vuejs" />,
        pack: "free",
        deploymentTarget: "kubernetes",
        iac: "kubernetes",
        type: "app",
        tags: [
            {
                position: "top",
                value: <span style={{ color: "GrayText", fontSize: 12 }}>Free</span>
            }
        ]
    },
    {
        key: "svelte",
        title: "Svelte",
        description: "Svelte is a tool for building fast web applications.",
        link: "https://raw.githubusercontent.com/microtica/templates/master/svelte/.microtica/template.yaml",
        avatar: <TemplateAvatar size="large" shape="square" name="svelte" />,
        pack: "free",
        deploymentTarget: "kubernetes",
        iac: "kubernetes",
        type: "app",
        tags: [
            {
                position: "top",
                value: <span style={{ color: "GrayText", fontSize: 12 }}>Free</span>
            }
        ]
    },
    {
        key: "gatsby",
        title: "Gatsby",
        description: "Gatsby enables developers to build fast, secure, and powerful websites using a React-based framework and innovative data layer that makes integrating different content, APIs, and services into one web experience incredibly simple.",
        link: "https://raw.githubusercontent.com/microtica/templates/master/gatsby/.microtica/template.yaml",
        avatar: <TemplateAvatar size="large" shape="square" name="gatsby" />,
        pack: "free",
        deploymentTarget: "kubernetes",
        iac: "kubernetes",
        type: "app",
        tags: [
            {
                position: "top",
                value: <span style={{ color: "GrayText", fontSize: 12 }}>Free</span>
            }
        ]
    },
    {
        key: "nestjs",
        title: "NestJS",
        description: "Nest (NestJS) is a framework for building efficient, scalable Node.js server-side applications. It uses progressive JavaScript, is built with and fully supports TypeScript.",
        link: "https://raw.githubusercontent.com/microtica/templates/master/nestjs/.microtica/template.yaml",
        avatar: <TemplateAvatar size="large" shape="square" name="nest" />,
        pack: "free",
        deploymentTarget: "kubernetes",
        iac: "kubernetes",
        type: "app",
        tags: [
            {
                position: "top",
                value: <span style={{ color: "GrayText", fontSize: 12 }}>Free</span>
            }
        ]
    },
    {
        key: "gin",
        title: "Gin",
        description: "Gin is a web framework written in Go (Golang). It features a martini-like API with performance that is up to 40 times faster thanks to httprouter.",
        link: "https://raw.githubusercontent.com/microtica/templates/master/gin/.microtica/template.yaml",
        avatar: <TemplateAvatar size="large" shape="square" name="gin" />,
        pack: "free",
        deploymentTarget: "kubernetes",
        iac: "kubernetes",
        type: "app",
        tags: [
            {
                position: "top",
                value: <span style={{ color: "GrayText", fontSize: 12 }}>Free</span>
            }
        ]
    },
    {
        key: "iris",
        title: "Iris",
        description: "Iris is the fastest HTTP/2 Go Web Framework. Easy to learn. Fast development with Code you control. Unbeatable cost-performance ratio.",
        link: "https://raw.githubusercontent.com/microtica/templates/master/iris/.microtica/template.yaml",
        avatar: <TemplateAvatar size="large" shape="square" name="iris" />,
        pack: "free",
        deploymentTarget: "kubernetes",
        iac: "kubernetes",
        type: "app",
        tags: [
            {
                position: "top",
                value: <span style={{ color: "GrayText", fontSize: 12 }}>Free</span>
            }
        ]
    },
    {
        key: "django4",
        title: "Django 4",
        description: "Django is a high-level Python web framework that encourages rapid development and clean, pragmatic design.",
        link: "https://raw.githubusercontent.com/microtica/templates/master/django4/.microtica/template.yaml",
        avatar: <TemplateAvatar size="large" shape="square" name="django" />,
        pack: "free",
        deploymentTarget: "kubernetes",
        iac: "kubernetes",
        type: "app",
        tags: [
            {
                position: "top",
                value: <span style={{ color: "GrayText", fontSize: 12 }}>Free</span>
            }
        ]
    },
    {
        key: EKS_KEY,
        title: "Amazon EKS",
        description: "Kubernetes infrastructure based on Amazon EKS.",
        link: "https://raw.githubusercontent.com/microtica/templates/master/aws-eks/template.yaml",
        avatar: <TemplateAvatar size="large" shape="square" name="eks" />,
        pack: "free",
        cloudProvider: "aws",
        iac: "cloudformation",
        type: "component",
        tags: [
            {
                position: "top",
                value: <span style={{ color: "GrayText", fontSize: 12 }}>Free</span>
            }
        ],
        group: "resources",
        repoUrl: "https://github.com/microtica/templates/tree/master/aws-eks"
    },
    {
        key: "fargate",
        title: "AWS Fargate",
        description: "Provides on-demand, right-sized compute capacity for containers.",
        link: "https://raw.githubusercontent.com/microtica/templates/master/aws-fargate/.microtica/template.yaml",
        avatar: <TemplateAvatar size="large" shape="square" name="fargate" />,
        pack: "free",
        cloudProvider: "aws",
        iac: "cloudformation",
        type: "component",
        tags: [
            {
                position: "top",
                value: <span style={{ color: "GrayText", fontSize: 12 }}>Free</span>
            }
        ],
        group: "resources"
    },
    {
        key: "spa",
        title: "SPA on CloudFront",
        description: "An empty ReactJS application hosted on S3 and exposed through Amazon CloudFront on your own domain.",
        link: "https://raw.githubusercontent.com/microtica/templates/master/aws-spa-reactjs/.microtica/template.yaml",
        avatar: <TemplateAvatar size="large" shape="square" name="spa" />,
        pack: "free",
        cloudProvider: "aws",
        iac: "cloudformation",
        type: "component",
        tags: [
            {
                position: "top",
                value: <span style={{ color: "GrayText", fontSize: 12 }}>Free</span>
            }
        ],
        group: "resources"
    },
    {
        key: "eks-spot",
        title: "Amazon EKS Spot",
        description: "Kubernetes infrastructure based on Amazon EKS using Spot instances for Kubernetes nodes.",
        link: "https://raw.githubusercontent.com/microtica/templates/master/aws-eks-spot/template.yaml",
        avatar: <TemplateAvatar size="large" shape="square" name="eks-spot" />,
        pack: "free",
        cloudProvider: "aws",
        iac: "cloudformation",
        type: "component",
        tags: [
            {
                position: "top",
                value: <span style={{ color: "GrayText", fontSize: 12 }}>Free</span>
            }
        ],
        group: "resources"
    }
];

export interface IFramework {
    name: string,
    type: "frontend" | "backend",
    buildScript?: string,
    buildDir?: string,
    port?: string,
    dockerfilePort: string
};
export const FRAMEWORKS: IFramework[] = [
    {
        name: "NodeJS",
        buildScript: "build",
        buildDir: "dist",
        port: "3000",
        type: "backend",
        dockerfilePort: "3000"
    },
    {
        name: "NextJS",
        buildScript: "build",
        buildDir: ".next",
        port: "3000",
        type: "backend",
        dockerfilePort: "3000"
    },
    {
        name: "NuxtJS",
        buildScript: "build",
        buildDir: ".nuxt",
        port: "3000",
        type: "backend",
        dockerfilePort: "3000"
    },
    {
        name: "ReactJS",
        buildScript: "build",
        buildDir: "build",
        port: "8000",
        type: "frontend",
        dockerfilePort: "80"
    },
    {
        name: "Angular",
        buildScript: "build",
        buildDir: "dst",
        port: "4200",
        type: "frontend",
        dockerfilePort: "80"
    },
    {
        name: "VueJS",
        buildScript: "build",
        buildDir: "dist",
        port: "8080",
        type: "frontend",
        dockerfilePort: "80"
    },
    {
        name: "Svelte",
        buildScript: "build",
        buildDir: "dist",
        port: "4173",
        type: "frontend",
        dockerfilePort: "80"
    },
    {
        name: "Gin",
        port: "8080",
        type: "backend",
        dockerfilePort: "8080"
    },
    {
        name: "Iris",
        port: "8080",
        type: "backend",
        dockerfilePort: "8080"
    },
    {
        name: "Gatsby",
        buildScript: "build",
        buildDir: "public",
        port: "9000",
        type: "backend",
        dockerfilePort: "9000"
    },
    {
        name: "NestJS",
        buildScript: "build",
        buildDir: "dist",
        port: "3000",
        type: "backend",
        dockerfilePort: "3000"
    },
    {
        name: "Strapi",
        port: "1337",
        type: "backend",
        dockerfilePort: "1337"
    },
    {
        name: "Python",
        port: "8000",
        type: "backend",
        dockerfilePort: "8000"
    },
    {
        name: "Django",
        port: "8000",
        type: "backend",
        dockerfilePort: "8000"
    },
    {
        name: "Other",
        buildScript: "build",
        buildDir: "dist",
        port: "8080",
        type: "backend",
        dockerfilePort: "80"
    }
];

export const CONFIG_CATEGORIES = ["advanced", "scaling", "autoscaling", "allocation", "alarm", "storage", "variables", "domain"];

export const MONITORING_CLUSTER_STATUS_ORDER = ["CS_HEALTHY", "CS_UPDATING", "CS_CONNECTED"];

export const NAMESPACE_ORDER = ["microtica", "default"];

export const DEFAULT_COST_ALLOCATION_TAG = "microtica:environment";